import { TIPOS_USUARIOS, TIPO_AVATAR } from '@/resources/constants';
var UsersMixin = {
  methods: {
    esAgente(tipo) {
      return (tipo.localeCompare(TIPOS_USUARIOS.USUARIO_TIPO_AGENTE) == 0);
    },
    esAcreedor(tipo) {
      return ([TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_PARTICULAR, TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_AUTONOMO, TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_ENTIDAD].includes(tipo))
    },
    esDeudor(tipo) {
      return ([TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_PARTICULAR, TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_AUTONOMO, TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_ENTIDAD].includes(tipo))
    },
    esNotario(tipo) {
      return (tipo.localeCompare(TIPOS_USUARIOS.USUARIO_TIPO_NOTARIO) == 0);
    },
    esEntidad(tipo) {
      return ([TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_ENTIDAD, TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_ENTIDAD].includes(tipo));
    },
    esAutonomo(tipo) {
      return ([TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_AUTONOMO, TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_AUTONOMO].includes(tipo));
    },
    getAvatar(gender, tipo) {
      if (tipo && this.esAgente(tipo) && !gender) {
        return require('@/assets/profile/icired.png');
      }
      switch (gender) {
        case TIPO_AVATAR.FEMALE:
          return require('@/assets/profile/female.png')
        case TIPO_AVATAR.MALE:
          return require('@/assets/profile/male.png')
        case TIPO_AVATAR.COMPANY:
          return require('@/assets/profile/company.png')
        case TIPO_AVATAR.MUG:
          return require('@/assets/profile/mug.png')
        case TIPO_AVATAR.ABSTRACT:
          return require('@/assets/profile/abstract.png')
        default:
          return require('@/assets/profile/company.png')
      }
    }
  }
};
export default UsersMixin;